import React, { useRef, useState } from 'react';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import PropTypes from 'prop-types';
import {
  FDDialog, FDTextButton, FDDialogTitle, FDDialogContent, FDDialogActions, FDPrimaryActionButton,
} from '@facet-wealth/design';
import { useIsVerticalOverflow } from 'Hooks/useIsVerticalOverflow';
import { TruncatedBox } from './TruncatedBox';

const MAX_CONTENT_HEIGHT_WHEN_TRUNCATING = 250;

export const TruncatedCard = ({ children, title, value }) => {
  const [showMore, setShowMore] = useState(false);
  const verticalOverflowRef = useRef();
  const isOverflowed = useIsVerticalOverflow(verticalOverflowRef, { maxSize: MAX_CONTENT_HEIGHT_WHEN_TRUNCATING });

  return (
    <>
      <TruncatedBox isTruncated={!showMore && isOverflowed} ref={verticalOverflowRef} maxContentHeightWhenTruncating={MAX_CONTENT_HEIGHT_WHEN_TRUNCATING}>
        {children}
      </TruncatedBox>
      {isOverflowed ? (
        <FDTextButton size={'sm'} onClick={() => setShowMore(!showMore)} label={showMore ? '- Read less' : '+ Read more'} />
      ) : null}
      {/* TODO DVH we are considering if we want to keep the modal or not.
      Either remove this Dialog or set open={showMore} depending on decision made in demo */}
      <FDDialog open={false} onClose={() => setShowMore(false)}>
        <FDDialogTitle value={title} />
        <FDDialogContent>
          <Richtext value={value} richtext />
        </FDDialogContent>
        <FDDialogActions>
          <FDPrimaryActionButton label={'Close'} onClick={() => setShowMore(false)} />
        </FDDialogActions>
      </FDDialog>
    </>
  );
};

TruncatedCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
